<template>
    <div v-loading="loading">
        <div>
            <IslandShopList
                :list="dataList"
                @clickEdit="clickEdit"
                @clickEnable="clickEnable"
                @clickDisable="clickDisable"
            />
        </div>

        <div>
            <PaginationComponent
                :pageObj="pageObj"
                @goPage="goPage"
            />
        </div>

        <div>
            <el-dialog
                v-model="openEditVisible"
                :title="i18n.tkey('lang_modify')"
                :width="myUtil.isMobile() ? '90%' : '600px'"
                align-center
                destroy-on-close
                :close-on-click-modal="false"
                :close-on-press-escape="false"
            >
                <MoveHallPosition
                    :record="editRecord"
                    :type="-1"
                    @save-complete="savePositionCallback"
                />
            </el-dialog>
        </div>
    </div>
</template>

<script setup>

import {inject, ref, onBeforeMount} from "vue";
import record15Api from "@/request/record15Api";
import myUtil from "@/util/util";
import PaginationComponent from "@/components/shopopee/common/paginationComponent.vue";
import IslandShopList from "@/components/shopopee/island/islandShopList.vue";
import MoveHallPosition from "@/components/shopopee/hall/moveHallPosition.vue";

const props = defineProps(["islandObj"])

const i18n = inject("i18n")
const loading = ref(false)

const pageObj = ref({})
const dataList = ref([])
const keyword = ref(null)
const pageNum = ref(1)
const pageSize = ref(10)

const openEditVisible = ref(false)
const editRecord = ref(null)

function getDataList(){
    loading.value = true

    const requset = record15Api.queryRecord15CompanyModel
    const params = requset.getParams()

    params.addinfo40 = keyword.value
    params.updatedid = props.islandObj.id
    params.pageNum = pageNum.value
    params.pageSize = pageSize.value

    requset.send(params, (res) => {
        loading.value = false

        if (res.code == 200){
            const obj = res.detail

            pageObj.value = obj
            dataList.value = obj.list

        }else{
            myUtil.alertError(res.msg)
        }

    })

}

function goPage(num){
    pageNum.value = num
    getDataList()
}

function clickDisable(obj){
    changeRecordStatus(obj.id, 0)
}

function clickEnable(obj){
    changeRecordStatus(obj.id, -1)
}

function clickEdit(obj){
    editRecord.value = obj
    openEditVisible.value = true
}

function savePositionCallback(){
    openEditVisible.value = false
    getDataList()
}

function changeRecordStatus(id, status){
    loading.value = true

    const request = record15Api.updateRecordStats
    const params = request.getParams()

    params.id = id
    params.recordno = status

    request.send(params, (res) => {
        loading.value = false

        if (res.code == 200){
            myUtil.alertSuccess(i18n.tkey("lang_operate_success"))
            getDataList()
        }else{
            myUtil.alertError(res.msg)
        }

    })

}

onBeforeMount(() => {
    if (null != props.islandObj){
        getDataList()
    }
})

</script>

<style scoped>

</style>